import _ from 'lodash';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GlossaryService } from '../glossary-service';
import { GetGlossary } from '@/infrastructure/api-functions/core-drafting-api/get-glossary-api';
import { UpdateGlossary } from '@/infrastructure/api-functions/core-drafting-api/update-glossary-api';
import { UploadGlossary } from '@/infrastructure/api-functions/core-drafting-api/upload-glossary-api';
import type { Glossary } from '../glossary-service';

@injectable()
export class GlossaryServiceImpl implements GlossaryService {
    constructor(
        @inject(GetGlossary)
        private _getGlossary: GetGlossary,
        @inject(UpdateGlossary)
        private _updateGlossary: UpdateGlossary,
        @inject(UploadGlossary)
        private _uploadGlossary: UploadGlossary,
    ) {}

    async getGlossary(): Promise<Glossary> {
        const glossary= await this._getGlossary.getGlossary();
        return {
            id: glossary.id,
            title: glossary.title,
            termPair: _.map(glossary.term_pair, (item) => ({
                chineseTerm: item.chinese_term,
                englishTerm: item.english_term,
            })),
        };
    }

    updateGlossary(params: Glossary): Promise<void> {
        return this._updateGlossary.updateGlossary({
            id: params.id,
            title: params.title,
            term_pair: _.map(params.termPair, (item) => ({
                chinese_term: item.chineseTerm,
                english_term: item.englishTerm,
            })),
        });
    }
    uploadGlossary(params: File): Promise<void> {
        return this._uploadGlossary.uploadGlossary(params);
    }
}
